export default __webpack_public_path__ + "static/media/walletLogo.ad31f4bc.svg";